import { defineMessages } from 'react-intl';

export default defineMessages({
    prQuoteValidityDays: {
        id: 'quoteandbind.views.ppl.quote.Quote Validity Days',
        defaultMessage: 'THIS QUOTE IS VALID FOR {quoteValidityDays} DAYS - COVERAGE IS NOT BOUND UNTIL A BINDER IS ISSUED',
    },
    note1: {
        id: 'quoteandbind.views.ppl.quote.note1',
        defaultMessage: 'NOTE: The terms we have offered are not necessarily identical to those requested in your apprication for insurance/ submission form, nor is {insuranceManagerNote1} obligated to offer such terms.   Please review the terms and conditions of this quote carefully.  Relevant policy forms may be obtained from the undersigned underwriter or refer to our website to locate the appricable forms (please note revision dates for the appropriate form).'
    }, 
    note2: {
        id: 'quoteandbind.views.ppl.quote.note2',
        defaultMessage: 'INSURANCE LICENSE NOTICE: {insuranceManagerNote2} has provided this quotation on the basis that you are duly licensed to sell insurance in the jurisdiction pertaining to this insurance risk.  By virtue of the fact that you have requested this quotation, you are representing to {insuranceManagerNote2} that you are a duly licensed insurance broker in the relevant jurisdiction.  {insuranceManagerNote2} may request a copy of such license at any time.'
    },
});
